import { render, staticRenderFns } from "./Popup.vue?vue&type=template&id=67d9f778&scoped=true&"
import script from "./Popup.vue?vue&type=script&lang=js&"
export * from "./Popup.vue?vue&type=script&lang=js&"
import style0 from "./Popup.vue?vue&type=style&index=0&id=67d9f778&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d9f778",
  null
  
)

export default component.exports